var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalborn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 20,
    viewBox: "0 0 197 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.184 0H171.39L166.892 19.9677H171.686L176.184 0ZM197 0H192.206L187.708 19.9677H192.502L197 0ZM62.1863 15.2504L65.601 0H60.8073L56.3092 19.9677H81.9192L82.9698 15.2504H62.1863ZM88.453 0L83.9548 19.9677H101.816C106.085 19.9677 110.32 16.5428 111.272 12.3425L107.529 7.62521H112.323C113.275 3.42488 110.583 0.0323122 106.314 0.0323122L88.453 0ZM102.9 15.2504H89.7992L90.4558 12.3425H106.479V12.3748C106.117 13.958 104.541 15.2504 102.9 15.2504ZM107.562 7.59289H91.5393L92.196 4.71729H105.297C106.905 4.71729 107.923 6.00969 107.562 7.59289ZM164.856 19.9677L166.564 12.3425L162.821 7.62521H167.614C168.566 3.42488 165.874 0.0323122 161.606 0.0323122H143.712L139.213 20H144.007L145.714 12.3748H161.737L160.03 20L164.856 19.9677ZM162.853 7.59289H146.831L147.487 4.71729H160.588C162.164 4.71729 163.182 6.00969 162.853 7.59289ZM116.099 0L111.601 19.9677H137.211L141.709 0H116.099ZM133.467 15.2504H117.445L119.809 4.74959H135.832L133.467 15.2504ZM45.4413 0H40.1223L27.6128 19.9677H32.4065L45.4413 0H50.7603L54.2735 19.9677H49.4798L45.4413 0ZM25.3145 0L23.6072 7.62521H7.5845L9.29183 0H4.49817L0 19.9677H4.79367L7.5845 7.62521L11.3275 12.3425H22.5237L20.8163 19.9677H25.61L30.1082 0H25.3145Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.977 0L187.708 19.9677H182.915L176.184 0H180.977Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalborn);
export default __webpack_public_path__ + "static/media/halborn.09dfe8053d0e452f91877b6400432404.svg";
export { ForwardRef as ReactComponent };